import React from 'react';

interface DietIconProps {
  type: 'veg' | 'non-veg' | 'eggs' | 'jain' | 'vegan';
  size?: number;
  className?: string;
}

export const DietIcon: React.FC<DietIconProps> = ({ 
  type, 
  size = 24, 
  className = '' 
}) => {
  const iconProps = {
    width: size,
    height: size,
    className: className,
    style: { display: 'block' }
  };

  switch (type) {
    case 'veg':
      return (
        <svg {...iconProps} viewBox="0 0 24 24" fill="none">
          <rect 
            x="2" 
            y="2" 
            width="20" 
            height="20" 
            rx="3" 
            fill="none" 
            stroke="#34C759" 
            strokeWidth="2"
          />
          <circle 
            cx="12" 
            cy="12" 
            r="6" 
            fill="#34C759"
          />
        </svg>
      );

    case 'non-veg':
      return (
        <svg {...iconProps} viewBox="0 0 24 24" fill="none">
          <rect 
            x="2" 
            y="2" 
            width="20" 
            height="20" 
            rx="3" 
            fill="none" 
            stroke="#FF3B30" 
            strokeWidth="2"
          />
          <polygon 
            points="12,6 18,16 6,16" 
            fill="#FF3B30"
          />
        </svg>
      );

    case 'eggs':
      return (
        <svg {...iconProps} viewBox="0 0 24 24" fill="none">
          <rect 
            x="2" 
            y="2" 
            width="20" 
            height="20" 
            rx="3" 
            fill="none" 
            stroke="#FF9500" 
            strokeWidth="2"
          />
          <ellipse 
            cx="12" 
            cy="12" 
            rx="5" 
            ry="7" 
            fill="#FF9500"
          />
        </svg>
      );

    case 'jain':
      return (
        <svg {...iconProps} viewBox="0 0 24 24" fill="none">
          <rect 
            x="2" 
            y="2" 
            width="20" 
            height="20" 
            rx="3" 
            fill="none" 
            stroke="#AF52DE" 
            strokeWidth="2"
          />
          <text 
            x="12" 
            y="16" 
            fontSize="14" 
            fontWeight="bold" 
            textAnchor="middle" 
            fill="#AF52DE"
          >
            J
          </text>
        </svg>
      );

    case 'vegan':
      return (
        <svg {...iconProps} viewBox="0 0 24 24" fill="none">
          <rect 
            x="2" 
            y="2" 
            width="20" 
            height="20" 
            rx="3" 
            fill="none" 
            stroke="#32D74B" 
            strokeWidth="2"
          />
          <text 
            x="12" 
            y="16" 
            fontSize="14" 
            fontWeight="bold" 
            textAnchor="middle" 
            fill="#32D74B"
          >
            V
          </text>
        </svg>
      );

    default:
      return null;
  }
};
